//STYLES
import styles from "./Footer.module.scss";

//ASSETS
import allariaLogo from "../../assets/images/icons/navbar/navbar-allaria-desktop-logo.svg";
import cnvLogo from "../../assets/images/icons/footer/cnv-logo.svg";
import instagramSocialLogo from "../../assets/images/icons/footer/instagram-social-logo.svg";
import linkedinSocialLogo from "../../assets/images/icons/footer/linkedin-social-logo.svg";
import qrLogo from "../../assets/images/icons/footer/qr-logo.svg";
import xSocialLogo from "../../assets/images/icons/footer/x-social-logo.svg";
import youtubeSocialLogo from "../../assets/images/icons/footer/youtube-social-logo.svg";

//HOOKS
import useScreenSize from "../../hooks/useScreenSize";

const Footer = () => {
  const {
    allarialogoContainer,
    cnvContainer,
    footerContainer,
    topRow,
    bottomRow,
    legalLinksContainer,
    qrContainer,
    socialContainer,
  } = styles;

  const { isMobile } = useScreenSize();

  const socialNetworks = [
    {
      name: "X",
      logo: xSocialLogo,
      href: "https://x.com/Allaria_SA",
    },
    {
      name: "Linkedin",
      logo: linkedinSocialLogo,
      href: "https://www.linkedin.com/company/allaria",
    },
    {
      name: "Instagram",
      logo: instagramSocialLogo,
      href: "https://www.instagram.com/allaria_sa/?hl=es",
    },
    {
      name: "Youtube",
      logo: youtubeSocialLogo,
      href: "https://www.youtube.com/@Allaria_SA",
    },
  ];

  if (isMobile) return null;

  return (
    <footer className={footerContainer}>
      <div className={topRow}>
        <div className={allarialogoContainer}>
          <img src={allariaLogo} alt="Allaria Logo" />
        </div>

        <div className={legalLinksContainer}>
          <a
            href="/doc/Términos-y-Condiciones.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Términos y Condiciones
          </a>
          <p>|</p>
          <a
            href="/doc/Politicas-de-Privacidad-Allaria.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Políticas de privacidad
          </a>
        </div>

        <div className={socialContainer}>
          {socialNetworks.map(({ name, logo, href }) => (
            <a key={name} href={href} target="_blank" rel="noreferrer">
              <img src={logo} alt={name} />
            </a>
          ))}
        </div>
      </div>

      <div className={bottomRow}>
        <div className={cnvContainer}>
          {/* Logo CNV con redirección */}
          <a
            href="https://www.argentina.gob.ar/cnv"
            target="_blank"
            rel="noreferrer"
          >
            <img src={cnvLogo} alt="CNV Logo" />
          </a>
          <p>
            Agente de Liquidación y Compensación Integral N° 24 de la CNV
            <br />
            Agente de Colocación y Distribución de FCI Integral N° 42 de la CNV
            <br />
            Agente de Colocación y Distribución de FCI N° 24 de la CNV
          </p>
        </div>

        <div className={qrContainer}>
          <p>
            Allaria S.A.
            <br />
            25 de Mayo 359 piso 12 | CP (C1002ABG) CABA, Argentina
            <br />
            Teléfono: 54 (11) 5555 6000
          </p>
          {/* Data Fiscal / QR con redirección */}
          <a
            href="https://auth.afip.gob.ar/contribuyente_/login.xhtml?action=SYSTEM&system=denuncias"
            target="_blank"
            rel="noreferrer"
          >
            <img src={qrLogo} alt="Data Fiscal" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
